exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".homepage.container-fluid {\n  margin: 0px; }\n\n.header {\n  height: 100px; }\n\n.homepageContent {\n  margin: 0px;\n  margin-top: 0px; }\n\n.suggestions {\n  margin-top: 20px;\n  text-align: center; }\n\nh2 {\n  line-height: 16px;\n  margin-bottom: 0;\n  margin-top: 24px; }\n", ""]);

// exports
